export default __webpack_public_path__ + "static/media/Magnum Ice Cream - Logo.639a1ee4.png";